import { createSelector } from 'reselect';
import Global from '../../store/global-selectors';
import { PackageService } from '../../services/package-service';

const returnServiceSelector = createSelector(
  (serviceId) => serviceId,
  (_, sellerLabelProviderId) => sellerLabelProviderId,
  (serviceId, sellerLabelProviderId) => {
    return {
      serviceId,
      sellerLabelProviderId,
    };
  },
);

const setReturnServiceAndPackageType = (state) => {
  const planId = (Global.selectOrderDetailsShipmentIdForReturns(state) || '').toString();
  const existingFulfillments = Global.selectEntitiesFulfillmentPlans(state) || {};
  const existingFulfillment = existingFulfillments[planId] || {};
  const standardPackageId = PackageService.getStandardPackageId();

  const existingPackages = existingFulfillment?.packages || [];
  existingFulfillment.packageTypeId = existingPackages[0]?.packageTypeId || standardPackageId;
  return [existingFulfillment];
};

export const getPrimaryOrFirstSellerLabelProvider = (labelProviderId, sellerLabelProviders) => {
  const primaryLabelProvider = sellerLabelProviders.find((slp) => slp.labelProviderId === labelProviderId && slp.isPrimaryAccount);
  if (primaryLabelProvider) {
    return primaryLabelProvider;
  }
  return sellerLabelProviders.find((slp) => slp.labelProviderId === labelProviderId) || {};
};

export const getReturnServiceShippingConfiguration = (state, salesOrderId) => {
  const fulfillmentIds =
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'fulfillmentIds',
    }) || [];
  const fulfillments = Global.selectEntitiesFulfillmentsByIds(state, { fulfillmentIds }) || [];

  const isCreatingReturnsFromShipment = Global.selectOrderDetailsisReturnsFromShipment(state);

  const nonVoidedFulfillments = isCreatingReturnsFromShipment
    ? setReturnServiceAndPackageType(state)
    : fulfillments.filter((fulfillment) => fulfillment && !fulfillment.isLabelVoided);
  const returnService = Global.selectSellerSellerSetting(state, {
    settingName: 'ReturnService',
  });

  if (!returnService) {
    const outboundService = nonVoidedFulfillments.length !== 1 ? '' : (nonVoidedFulfillments || [])[0]?.serviceId;
    const outboundSellerlabelProviderId = nonVoidedFulfillments.length !== 1 ? '' : (nonVoidedFulfillments || [])[0]?.sellerLabelProviderId;
    return returnServiceSelector(outboundService, outboundSellerlabelProviderId);
  }

  const matchingService = Global.selectSellerServices(state).find((service) => service.serviceId === returnService) || {};
  const { labelProviderId } = matchingService;
  const sellerLabelProviders = Global.selectSellerLabelProviders(state);
  const labelProvider = getPrimaryOrFirstSellerLabelProvider(labelProviderId, sellerLabelProviders);
  const { sellerLabelProviderId } = labelProvider;

  return returnServiceSelector(returnService, sellerLabelProviderId);
};
